import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";

const OtherFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  return (
    <div className="irf-grid" style={{ gridTemplateColumns: "1fr" }}>
      <div className="irf-field">
        <label>{t('insurance:other.coverageDetails')}</label>
        <textarea
          className="irf-textarea"
          value={data.coverage_details || ""}
          onChange={(e) => set("coverage_details", e.target.value)}
          placeholder={t('insurance:other.coverageDetailsPlaceholder')}
          rows={4}
        />
      </div>
    </div>
  );
};

export default OtherFields;
